export default theme => ({
  select: {
    margin: theme.spacing(0, 1, 0, 0),
    minWidth: 48,
    justifyContent: 'center',
    '& > div > div': {
      padding: theme.spacing(1, 2)
    },
    '& .MuiSelect-icon': {
      color: 'inherit'
    },
    '& .MuiButton-root.Mui-disabled': {
      color: theme.palette.text.disabled
    }
  },
  card: {
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'flex-end'
  }
});
